import { render, staticRenderFns } from "./ParticipantPostulationInformationExportComponent.vue?vue&type=template&id=0bec6968&"
import script from "./ParticipantPostulationInformationExportComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantPostulationInformationExportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports